export function hasMotifType (image, type) {
  if (!image.hasOwnProperty('motifType') || image.motifType === null) {
    return false
  }
  return image.motifType.code === type
}

export function isRoomImage (image) {
  if (
    hasMotifType(image, 'BD') || hasMotifType(image, 'W')
    || hasMotifType(image, 'RV') || hasMotifType(image, 'RK')
  ) {
    return true
  }
  return false
}

export function hasImageRoomsAssigned (image, galleries) {
  if (!galleries || !galleries.rooms) {
    return false
  }
  return Object.keys(galleries.rooms).some(roomId => {
    return galleries.rooms[roomId].order?.includes(image.id)
  })
}

export function isImageConfirmed (image) {
  return (image.hasOwnProperty('confirmationTicket') &&
      typeof image.confirmationTicket === 'string')
    || image.confirmed
}
